import { createTheme } from '@mui/material/styles';

export default createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
  },
  palette: {
    background: {
      default: '#333333',
    },
    primary: {
      main: '#46728f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#a94442',
    },
    error: {
      main: '#d32f2f',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#F4B860',
    },
    text: {
      primary: 'rgba(0,0,0,1)',
      secondary: 'rgba(0,0,0,0.75)',
      disabled: 'rgba(0,0,0,0.5)',
    },
  },
  typography: {
    h1: {
      fontSize: '1.6rem',
    },
    h2: {
      fontSize: '1.5rem',
    },
    h3: {
      fontSize: '1.35rem',
    },
    h4: {
      fontSize: '1.2rem',
    },
    h5: {
      fontSize: '1.0rem',
    },
  },
});
